export default __webpack_public_path__ + "static/media/logo_headphones_animated.aba42a82.svg";